let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ee2TX")).then(() => parcelRequire('f7IhQ'));